// ---------------------------------------------------------------------------
// CLIENT-SIDE TTS NORMALIZER — minimal subset of the backend rules.
// Used to clean SSE streaming chunks BEFORE rendering the agent bubble when
// voice:true is active (audio is normalised server-side; the *displayed* text
// must match so the user does not read "**5000 FCFA**" while ElevenLabs says
// "cinq mille francs CFA").
//
// ⚠️  Keep this file in sync with /app/backend-node/ttsNormalizer.js for the
// two rules below. We only port `strip_markdown` + `expand_currency` — every
// other backend rule (numbers, dates, phones, acronyms, punctuation) stays
// server-only because they would mangle on-screen readability.
// ---------------------------------------------------------------------------

function stripMarkdown(text) {
  let t = text;
  t = t.replace(/```[\s\S]*?```/g, '');                 // fenced code blocks
  t = t.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');        // [label](url) → label
  t = t.replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1');       // ![alt](url)  → alt
  t = t.replace(/<[^>]+>/g, '');                        // raw HTML tags
  t = t.replace(/\[\d{1,2}\]/g, '');                    // citations [1] [2]
  t = t.replace(/^\s*[-*+]\s+/gm, '');                  // bullet lines
  t = t.replace(/^\s*\d+\.\s+/gm, '');                  // numbered lists
  t = t.replace(/^\s{0,3}#{1,6}\s+/gm, '');             // # ## ### headings
  t = t.replace(/[*_~`#]/g, '');                        // residual markers
  t = t.replace(/={3,}/g, '');                          // === decorative dividers
  return t;
}

function expandCurrency(text) {
  let t = text;
  t = t.replace(/\bF\.?\s?CFA\b/gi, 'francs CFA');
  t = t.replace(/\bFCFA\b/gi, 'francs CFA');
  t = t.replace(/\bXOF\b/g, 'francs CFA');
  t = t.replace(/€/g, ' euros');
  t = t.replace(/\$/g, ' dollars');
  t = t.replace(/£/g, ' livres');
  return t;
}

const CLIENT_RULES = {
  strip_markdown: stripMarkdown,
  expand_currency: expandCurrency,
};

const CLIENT_DEFAULT = ['strip_markdown', 'expand_currency'];

export function normalizeForDisplay(text, rules = CLIENT_DEFAULT) {
  if (!text || typeof text !== 'string') return '';
  let out = text;
  for (const r of rules) {
    const fn = CLIENT_RULES[r];
    if (typeof fn === 'function') out = fn(out);
  }
  return out;
}

export const CLIENT_TTS_RULES = CLIENT_DEFAULT;
